import { useScreenSizeStore } from '/@/store/modules/screenSize'

/**
 * @name useScreenSize
 * @description A composable function that returns the current screen size based on the window width
 * This is now a compatibility wrapper around the store for existing code
 * @see [Figma Breakpoints](https://www.figma.com/design/Hd28nOIFlXADsZkjxc3T8Z/Design-System?node-id=664-906&m=dev)
 * @deprecated Consider using useScreenSizeStore() directly for better performance
 */
export const useScreenSize = () => {
  const store = useScreenSizeStore()

  return {
    screens: store.screens,
    currentScreen: store.currentScreen,
    isXs: store.isXs,
    isSm: store.isSm,
    isMd: store.isMd,
    isLg: store.isLg,
    isXl: store.isXl,
    is2Xl: store.is2Xl,
    smallerThan: store.smallerThan,
    biggerThan: store.biggerThan,

    // NEW: Additional utilities also available through composable
    isMobile: store.isMobile,
    isTablet: store.isTablet,
    isDesktop: store.isDesktop,
    smAndUp: store.smAndUp,
    mdAndUp: store.mdAndUp,
    lgAndUp: store.lgAndUp,
    xlAndUp: store.xlAndUp,

    // Vuetify-inspired additional utilities
    greaterThan: store.greaterThan,
    isMobileOrTablet: store.isMobileOrTablet,
    isTouch: store.isTouch,
    smAndDown: store.smAndDown,
    mdAndDown: store.mdAndDown,
    lgAndDown: store.lgAndDown,
    xsOnly: store.xsOnly,
    orientation: store.orientation,
    isLandscape: store.isLandscape,
    isPortrait: store.isPortrait,
    aspectRatio: store.aspectRatio,
    thresholds: store.thresholds,
  }
}
